import axios from "axios";
import { getToken, clearToken } from "./App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers["X-App-Token"] = token;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) => {
  if (!path) return null;
  const token = getToken();
  return `${API}/files/${path}?auth=${encodeURIComponent(token || "")}`;
};
